
import FormLayout from "../../../../components/layout/FormLayoutClient";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router";
import Input from "../../../../components/inputs/Input";
import InputTextArea from "../../../../components/inputs/InputTextArea";
import InputRating from "../../../../components/inputs/InputRating";
import InputSelect from "../../../../components/inputSelect";
import Button from "../../../../components/button/Button";
import Str from "../../../../helpers/Str";
import useModal from "../../../../hooks/useModal";
import Modal from "../../../../components/modal/Modal";
import Alert from "../../../../helpers/Alert";
import { IoClose } from "react-icons/io5";
import DocumentButton from "../../../../components/button/DocumentButton";
import {CgSpinner} from "react-icons/cg";
import {useNavigate} from "react-router-dom";
import contactApi from "../../../../services/contactApi";
import Rating from "../../../../components/inputs/InputRating";
import {AddCircleHalfDot, Delete, Doc, Download, Pdf} from "../../../../components/Icons";

export default function FormClientMessage() {
    const defaltValues = {
        id: '',
        subject: '',
        contact_type: '',
        status: '',
        created_at: '',
        finalized_at: '',
        message: '',
        response_message: '',
        mensages: [],
        file: null
    }
    const navigate = useNavigate();
    const [state, setState]: any = useState(defaltValues);
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [isRated, setIsRated] = useState(false);
    const { modalProps, open, close } = useModal();
    const [filesScreen, setFilesScreen] = useState([]);

    const openModalRating = async () => {
        setLoading(true);

        // @ts-ignore
        const {data, isError} = await contactApi.one(params.id.toString());

        setLoading(false);
        open()
    }

    const onSaveRating = async () =>{
        try {
            if (!params.id) {
                return;
            }

            const contact = {
                rating: state.rating
            };
    
            const { data, isError } = await contactApi.update(params.id.toString(), contact);
            
            if (isError) {
                Alert.error('Erro ao avaliar');
                return;
            }
    
            setIsRated(true);
            getState()
            Alert.success('Avaliado com sucesso');
            close();
        } catch (error) {
            Alert.error('Erro ao avaliar');
        }
    }

    const handleChange = (value: any, input: string) => {
        setState({...state, [input]: value});
    };

    const getState = async () => {
        // @ts-ignore
        const {data, isError} = await contactApi.one(params.id.toString());

        setState({
            id: data.id,
            subject: data.subject,
            contact_type: data.contact_type,
            contact_type_description: data.contact_type_description,
            status: data.status,
            status_description: data.status_description,
            created_at: Str.convertDateCreatedAt(data.created_at),
            finalized_at: Str.convertDateCreatedAt(data.finalized_at),
            message: data.message,
            response_message: data.response_message,
            rating: data.rating,
            mensages: data.mensages
        })
        setIsRated(data.rating !== null);
        setLoading(false)
    }

    useEffect(() => {
        if (params.id){
            getState()
        }else{
            setLoading(false)
        }
    },[])

    const onSelectFiles = (data: any) => {
        if (data.length){
            const newState = {...state};
            let filesData = data
            let filesBase64: any[] = []
            console.log(data);
            Str.convertFileToBase64(data[0], (str: any) => filesBase64.push(str), true)
            newState.file = filesBase64
            setState(newState)
            setFilesScreen(filesData);
            setState(newState)
        }

    }

    const removeFile = () => {
        const newState = {...state};
        newState.file = null;
        setFilesScreen([]);
        setState(newState)
    }

    return(
        <>
            <FormLayout
                title={'Mensagens'}
                urlReturn={'/cliente/mensagens'}
                state={state}
                setState={setState}
                apiData={contactApi}
                defaltValues={defaltValues}
            >
                {
                    loading ?
                        <span className="flex items-center justify-center h-7">
                            <svg className="animate-spin -ml-1 mr-3 h-[14px] w-[14px] text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </span>
                        :
                        <>
                            <div className={'flex  w-full '}>
                                <div className={'sm:w-full grid p-3'}>
                                    <div className="mt-3 grid grid-cols-12 gap-3">
                                        <Input
                                            label={'Assunto'}
                                            disabled
                                            value={state.subject}
                                            className={'md:col-span-12 xs:col-span-12 content-center'}
                                        />
                                    </div>
                                    <div className="mt-3 grid grid-cols-12 gap-3">
                                        <Input
                                            label={'Tipo de contato'}
                                            disabled
                                            value={state.contact_type_description}
                                            className={'md:col-span-3 xs:col-span-12 content-center'}
                                        />
                                        <Input
                                            label={'Situação'}
                                            disabled
                                            value={state.status_description}
                                            className={'md:col-span-3 xs:col-span-12 content-center'}
                                        />
                                        <Input
                                            label={'Abertura'}
                                            disabled
                                            value={state.created_at}
                                            className={'md:col-span-3 xs:col-span-12 content-center'}
                                        />
                                        <Input
                                            label={'Conclusão'}
                                            disabled
                                            value={state.finalized_at}
                                            className={'md:col-span-3 xs:col-span-12 content-center'}
                                        />
                                    </div>
                                    <div className="mt-3 grid-cols-12 gap-3 flex flex-col">
                                        <div className={'grid grid-cols-12'}>
                                            <label>Mensagens</label>
                                        </div>
                                        <div className={'grid grid-cols-12 text-[25px] text-system-primary mt-4'}>
                                            <DocumentButton
                                                multiple={false}
                                                classeName={'hover:text-[#49E268]'}
                                                onSelect={(e: any) => onSelectFiles(e)}
                                                id={'files'}
                                                icon={<AddCircleHalfDot/>}
                                                accept={'.doc, .docx,.ppt, .pptx,.txt,.pdf'}
                                            />
                                        </div>
                                        {
                                            filesScreen.length ?
                                                <div className={'flex flex-wrap gap-5 mt-5'}>
                                                    {
                                                        filesScreen.map((file: any) => {
                                                            const icon  = (file.type === 'application/pdf' || file.type === 'pdf') ? <Pdf className={'text-border text-[35px]'}/> : <Doc className={'text-border text-[35px]'}/>
                                                            return  (
                                                                <div className={'flex gap-3'}>
                                                                    <div className={'flex w-[25rem] border border-[#13131A] hover:border-border items-center justify-between  p-3 h-[73px] rounded-xl bg-[#13131A]'}>
                                                                        <div className={'text-[#B5B5BE] flex gap-2 items-center'}>
                                                                            {icon} <div className={'text-[14px]'}>{file.name ? file.name : file.original_name}</div>
                                                                        </div>
                                                                        <div className={'flex text-[#64646C] gap-4'}>
                                                                            <div >
                                                                                {Str.convertDateCreatedAt(file.created_at)}
                                                                            </div>
                                                                            {/*{
                                                                                file.original_name || file.name ?
                                                                                    <div>
                                                                                        <button type={'button'} onClick={()=> window.open(file.file_path, "_blank")} className={'hover:text-border'}>
                                                                                            <Download/>
                                                                                        </button>
                                                                                    </div>
                                                                                    :
                                                                                    ''
                                                                            }*/}
                                                                        </div>
                                                                    </div>
                                                                    <div className={'flex flex-col gap-3 justify-center text-[20px] text-system-primary'}>
                                                                        <button type={'button'} onClick={() => removeFile()} className={'hover:text-[#F44E4D]'}>
                                                                            <Delete/>
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                            )
                                                        })
                                                    }
                                                </div>
                                                :
                                                ''
                                        }
                                        <InputTextArea
                                            /*disabled*/
                                            value={state.message}
                                            setValue={(v) => handleChange(v, 'message')}
                                            className={'md:col-span-12 xs:col-span-12 content-center'}
                                            rows={4}
                                        />

                                    </div>
                                    <div>
                                        Respostas
                                    </div>
                                    {
                                        state.mensages && state.mensages.map((message: any) => {

                                            const subtitle = message.user_create.name+' '+Str.convertDateStringComplet(message.created_at);
                                            const icon  = (message.type === 'application/pdf' || message.type === 'pdf') ? <Pdf className={'text-border text-[35px]'}/> : <Doc className={'text-border text-[35px]'}/>

                                            return (
                                                <div className="mt-3 grid-cols-12 gap-3 flex flex-col">
                                                    {
                                                        message.file_path ?
                                                            <div className={'mb-[-20px] '}>
                                                                <div className={'flex gap-3'}>
                                                                    <div className={'flex w-[25rem] border border-[#13131A] hover:border-border items-center justify-between  p-3 h-[73px] rounded-xl bg-[#13131A]'}>
                                                                        <div className={'text-[#B5B5BE] flex gap-2 items-center'}>
                                                                            {icon} <div className={'text-[14px]'}>{message.file_name ? message.file_name : message.original_name}</div>
                                                                        </div>
                                                                        <div className={'flex text-[#64646C] gap-4'}>
                                                                            <div >
                                                                                {Str.convertDateCreatedAt(message.created_at)}
                                                                            </div>
                                                                            {
                                                                                message.file_name ?
                                                                                    <div>
                                                                                        <button type={'button'} onClick={()=> window.open(message.file_path, "_blank")} className={'hover:text-border'}>
                                                                                            <Download/>
                                                                                        </button>
                                                                                    </div>
                                                                                    :
                                                                                    ''
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    {/*<div className={'flex flex-col gap-3 justify-center text-[20px] text-system-primary'}>
                                                                        <button type={'button'} onClick={() => removeFile()} className={'hover:text-[#F44E4D]'}>
                                                                            <Delete/>
                                                                        </button>
                                                                    </div>*/}
                                                                </div>
                                                            </div>
                                                            :
                                                            ''
                                                    }

                                                    <div className="mt-3 grid grid-cols-12 gap-3 mb-2">
                                                        <InputTextArea
                                                            disabled
                                                            value={message.message}
                                                            /*setValue={(v) => handleChange(v, 'response_message')}*/
                                                            className={'md:col-span-12 xs:col-span-12 content-center'}
                                                            rows={4}
                                                            subTitle={subtitle}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                    {/*<div className="mt-3 grid grid-cols-12 gap-3">
                                        <InputTextArea
                                            label={'Mensagem'}
                                            disabled
                                            value={state.message}
                                            className={'md:col-span-12 xs:col-span-12 content-center'}
                                            rows={4}
                                        />
                                    </div>
                                    <div className="mt-3 grid grid-cols-12 gap-3">
                                        <InputTextArea
                                            label={'Resposta'}
                                            disabled
                                            value={state.response_message}
                                            className={'md:col-span-12 xs:col-span-12 content-center'}
                                            rows={4}
                                        />
                                    </div>*/}
                                </div>
                            </div>
                            {
                                state.finalized_at && state.status === "Finalizado" && (
                                    <div className={'sticky top-[95vh] flex gap-4 p-5 border-t border-system-gray-gray80 justify-end'}>
                                        <Button loading={loading} onClick={openModalRating} type={'button'} className={'w-[100px]'}>
                                            {isRated ? 'Avaliação' : 'Avaliar'}
                                        </Button>
                                    </div>
                                )
                            }
                        </>
                }
            </FormLayout>
            <Modal
                size={'mdm'}
                title={"Avaliar Atendimento"}
                footer={!isRated}
                btnOnclickName={'Enviar Avaliação'}
                onClick={() => onSaveRating()}
                btnRowReverse={true}
                {...modalProps}
            >
                {
                    loading ?
                        <span className="flex items-center justify-center h-7">
                            <svg className="animate-spin -ml-1 mr-3 h-[14px] w-[14px] text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </span>
                        :
                        <>
                            <div className={'flex w-full justify-center'}>
                                <div className={'col-span-4 flex items-center md:p-3 md:ml-3 md:gap-2'}>
                                    <InputRating value={state.rating} setValue={(value) => setState({...state, rating: value})} />
                                </div>

                            </div>
                            <div className={'sm:w-full grid p-3'}>
                                <div className="grid grid-cols-12 gap-3">
                                </div>
                            </div>
                        </>
                }
            </Modal>
        </>
    )
}
